// 引入库
// ==============================
import Vue from 'vue'
import ElementUI from 'element-ui'

Vue.config.productionTip = false

// 引入样式
// ==============================
import 'element-ui/lib/theme-default/index.css'
import '../static/css/main.css'

// 引入配置
// ==============================
import 'babel-polyfill'
import router from '@/config/router'
import App from './App'
import store from '@/config/store'
import axios from '@/config/http'
import lodash from 'lodash'
// import utils from '@/config/cookieUtils'
import VueI18n from 'vue-i18n'
// 注册所有公共组件
// ==============================
import './config/register'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

// 渲染视图
// ==============================
Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.prototype.axios = axios
Vue.prototype._ = lodash

let currentLang = window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US'
if (currentLang !== 'en_US') {
  currentLang = 'zh_CN'
}
const i18n = new VueI18n({
  locale: currentLang,    // 语言标识
  messages: {
    'zh_CN': require('./lang/zh'),   // 中文语言包
    'en_US': require('./lang/en')    // 英文语言包
  }
})

if (currentLang === 'en-US') {
  Vue.use(ElementUI, { enLocale })
  locale.use(enLocale)
} else {
  Vue.use(ElementUI, { zhLocale })
  locale.use(zhLocale)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  axios,
  lodash,
  render: function (createElement) {
    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
      window.addEventListener('hashchange', () => {
        let currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
    return createElement(App)
  }
})



// WEBPACK FOOTER //
// ./src/main.js